import { areShallowEqual } from "../are-shallow-equal";
export class FormGroupContext {
    constructor() {
        this.valuePropertyChangeHandlers = {};
        /*
        this.setValueProperty = this.setValueProperty.bind(this);
        this.handleValuePropertyChange = this.handleValuePropertyChange.bind(this);
        */
    }
    get value() {
        if (this.props.group) {
            return (this.props.group.value && this.props.group.value[this.props.groupKey]);
        }
        return this.props.value;
    }
    setValue(value) {
        if (this.props.group) // has a parent group
         {
            this.props.group.setValueProperty(this.props.groupKey, value);
        }
        else {
            this.props.onChange({ target: {
                    value: value,
                    name: this.props.name,
                } });
        }
    }
    setValueProperty(key, value) {
        var newVal;
        if (this.value instanceof Array) {
            newVal = this.value.slice();
            newVal[key] = value;
        }
        else {
            newVal = Object.assign(Object.assign({}, this.value), { [key]: value });
        }
        this.setValue(newVal);
    }
    mergeValue(updater) {
        var newVal;
        if (this.value) {
            if (this.value instanceof Array) {
                newVal = this.value.slice();
                for (var i in updater) {
                    newVal[i] = updater[i];
                }
            }
            else {
                newVal = Object.assign(Object.assign({}, this.value), updater);
            }
        }
        else {
            newVal = updater;
        }
        this.setValue(newVal);
    }
    handleValuePropertyChange(key, event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setValueProperty(key, value);
    }
    get computedChildrenProps() {
        var _a;
        var sameChildrenProps = areShallowEqual(this._prevChildrenProps, this.props.childrenProps);
        var sameParentChildrenProps = true;
        if (this.props.group) {
            sameParentChildrenProps =
                areShallowEqual(this._prevParentChildrenProps, this.props.group.computedChildrenProps);
            this._prevParentChildrenProps = this.props.group.computedChildrenProps; // update the previous for caching
        }
        this._prevChildrenProps = this.props.childrenProps; // update the previous for caching
        if (sameParentChildrenProps && sameChildrenProps) {
            return this._computedChildrenProps;
        }
        if (this.props.group || this.props.childrenProps) {
            // inherits the root child props
            return this._computedChildrenProps = Object.assign(Object.assign({}, (_a = this.props.group) === null || _a === void 0 ? void 0 : _a.computedChildrenProps), this.props.childrenProps);
        }
        else {
            return this._computedChildrenProps = null;
        }
    }
    getHandleValueProperyChange(key) {
        return this.valuePropertyChangeHandlers[key] ||
            (this.valuePropertyChangeHandlers[key] = (evt) => this.handleValuePropertyChange(key, evt));
    }
}
//# sourceMappingURL=form-group-context.js.map